import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
import { KotlinLogging_instance3jisqrkz0n5up as KotlinLogging_instance } from './kotlin-logging.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.a8n_1 = RpcInternalCommonLoggerFactoryImpl_instance;
  }
  c8m(name) {
    return this.a8n_1.b8n(name);
  }
}
class RpcInternalDumpLoggerContainer$provide$1 {
  c8n() {
    var tmp0_safe_receiver = RpcInternalDumpLoggerContainer_instance.d8n_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c8n();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  e8n(tags, message) {
    if (this.c8n()) {
      var tmp0_safe_receiver = RpcInternalDumpLoggerContainer_instance.d8n_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.e8n(tags.slice(), message);
      }
    }
  }
}
class RpcInternalDumpLoggerContainer {
  constructor() {
    this.d8n_1 = null;
  }
  f8n() {
    return new RpcInternalDumpLoggerContainer$provide$1();
  }
}
class RpcInternalCommonLoggerFactoryImpl {
  b8n(name) {
    return new RpcInternalCommonLoggerImpl(KotlinLogging_instance.c8m(name));
  }
}
class RpcInternalCommonLoggerImpl {
  constructor(logger) {
    this.g8n_1 = logger;
  }
  w8l(msg) {
    this.g8n_1.w8l(msg);
  }
  z8l(msg) {
    this.g8n_1.z8l(msg);
  }
  a8m(t, msg) {
    this.g8n_1.a8m(t, msg);
  }
  y8l(msg) {
    this.g8n_1.y8l(msg);
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
var RpcInternalDumpLoggerContainer_instance;
function RpcInternalDumpLoggerContainer_getInstance() {
  return RpcInternalDumpLoggerContainer_instance;
}
var RpcInternalCommonLoggerFactoryImpl_instance;
function RpcInternalCommonLoggerFactoryImpl_getInstance() {
  return RpcInternalCommonLoggerFactoryImpl_instance;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(RpcInternalDumpLoggerContainer$provide$1);
initMetadataForObject(RpcInternalDumpLoggerContainer, 'RpcInternalDumpLoggerContainer');
initMetadataForObject(RpcInternalCommonLoggerFactoryImpl, 'RpcInternalCommonLoggerFactoryImpl');
initMetadataForClass(RpcInternalCommonLoggerImpl, 'RpcInternalCommonLoggerImpl');
//endregion
//region block: init
RpcInternalDumpLoggerContainer_instance = new RpcInternalDumpLoggerContainer();
RpcInternalCommonLoggerFactoryImpl_instance = new RpcInternalCommonLoggerFactoryImpl();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1nbjfh65ymx8,
  RpcInternalDumpLoggerContainer_instance as RpcInternalDumpLoggerContainer_instance19d4gfuy68062,
};
//endregion
